import React, { useState } from "react";
import { API_BASE_URL } from "../../../config";
import { deleteLocalSong } from "../../../utils/songStorage";
import { authFetch } from "../../../utils/auth";
import "../../../assets/css/music.css";

function PlayIcon({ size = 16 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
            <polygon points="5 3 19 12 5 21 5 3" />
        </svg>
    );
}

function TrashIcon({ size = 14 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="3 6 5 6 21 6" />
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
        </svg>
    );
}

function SongCard({ song, lang_id, user_id, isCustom = false, onDeleted }) {
    const [imageError, setImageError] = useState(false);
    const [showConfirmDelete, setShowConfirmDelete] = useState(false);
    const [popupNotice, setPopupNotice] = useState(null);

    const isCustomTrack = isCustom || (song.id && String(song.id).startsWith("custom_"));

    const formatDuration = (seconds) => {
        if (!seconds) return "0:00";
        const m = Math.floor(seconds / 60);
        const s = Math.floor(seconds % 60);
        return `${m}:${s < 10 ? "0" : ""}${s}`;
    };

    const handleOpenSong = () => {
        window.location.href = `/song?song_id=${song.id}`;
    };

    const handleDeleteSong = (e) => {
        e.stopPropagation();
        setShowConfirmDelete(true);
    };

    const handleConfirmDelete = async () => {
        setShowConfirmDelete(false);
        try {
            await deleteLocalSong(song.id);
            await authFetch(`${API_BASE_URL}/api/songs/custom/${song.id}`, {
                method: "DELETE"
            });
            if (onDeleted) {
                onDeleted(song.id);
            }
        } catch (err) {
            console.error("Error deleting song:", err);
            setPopupNotice("Failed to delete song.");
        }
    };

    const gradient = song.cover_gradient || "linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)";
    const hasCoverImage = Boolean(song.cover_image) && !imageError;

    return (
        <>
            <article className={`song-card ${isCustomTrack ? "song-card--custom" : ""}`} onClick={handleOpenSong}>
                <div
                    className="song-card__cover"
                    style={{ background: hasCoverImage ? "#111" : gradient }}
                >
                    {hasCoverImage ? (
                        <img
                            src={song.cover_image}
                            alt={`${song.title} titlecard`}
                            className="song-card__image"
                            onError={() => setImageError(true)}
                        />
                    ) : (
                        <div className="song-card__vinyl">
                            <div className="song-card__vinyl-inner" />
                        </div>
                    )}
                </div>

                <div className="song-card__info">
                    <h4 className="song-card__title" title={song.title}>{song.title}</h4>
                    <p className="song-card__artist">{song.artist}</p>
                </div>

                <div className="song-card__footer">
                    <div className="song-card__meta-tags">
                        <span className="song-card__tag">{formatDuration(song.duration)}</span>
                        <span className="song-card__tag">{song.lines_count || 0} lines</span>
                    </div>

                    <div className="song-card__actions">
                        <button
                            className="song-card__play-btn"
                            onClick={(e) => {
                                e.stopPropagation();
                                handleOpenSong();
                            }}
                        >
                            <PlayIcon size={14} />
                            <span>Listen</span>
                        </button>

                        {isCustomTrack && (
                            <button
                                className="song-card__delete-btn"
                                onClick={handleDeleteSong}
                                title="Delete song from device and library"
                            >
                                <TrashIcon size={14} />
                            </button>
                        )}
                    </div>
                </div>
            </article>

            {/* In-app Delete Confirmation Popup */}
            {showConfirmDelete && (
                <div className="song-modal-overlay" onClick={(e) => { e.stopPropagation(); setShowConfirmDelete(false); }}>
                    <div className="song-confirm-popup" onClick={(e) => e.stopPropagation()}>
                        <h4 className="song-confirm-popup__title">Delete Song</h4>
                        <p className="song-confirm-popup__text">
                            Are you sure you want to delete "{song.title}"?
                        </p>
                        <div className="song-confirm-popup__actions">
                            <button
                                className="song-confirm-popup__btn song-confirm-popup__btn--cancel"
                                onClick={(e) => { e.stopPropagation(); setShowConfirmDelete(false); }}
                            >
                                Cancel
                            </button>
                            <button
                                className="song-confirm-popup__btn song-confirm-popup__btn--delete"
                                onClick={(e) => { e.stopPropagation(); handleConfirmDelete(); }}
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* In-app Notice Popup */}
            {popupNotice && (
                <div className="song-modal-overlay" onClick={(e) => { e.stopPropagation(); setPopupNotice(null); }}>
                    <div className="song-confirm-popup" onClick={(e) => e.stopPropagation()}>
                        <h4 className="song-confirm-popup__title">Notice</h4>
                        <p className="song-confirm-popup__text">{popupNotice}</p>
                        <div className="song-confirm-popup__actions">
                            <button
                                className="song-confirm-popup__btn song-confirm-popup__btn--cancel"
                                onClick={(e) => { e.stopPropagation(); setPopupNotice(null); }}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default SongCard;

